module.exports = __webpack_public_path__ + "img/ch58.28563400.jpg";